// extracted by mini-css-extract-plugin
module.exports = {"label":"PermissionsCard_label_2y0ED","scroll":"PermissionsCard_scroll_2z8tm","DetailSeparator_container_1ijFZ":"PermissionsCard_DetailSeparator_container_1ijFZ_1Xbad"};